import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const DesignProcedureHalfFullAddSub = () => (
  <DSDModuleSubtopic
    title="Design Procedure, Half Adder, Full Adder, Half Subtractor, Full Subtractor"
    videos={[
      "https://www.youtube.com/embed/Pjw8t-bGSBo",
      "https://www.youtube.com/embed/5XbRIVWFRIw",
      "https://www.youtube.com/embed/lqN8xLTtdaA"
    ]}
    takeaways={[
      { text: "Learn the implementation of full adder from half adder." },
      { text: "Learn the design procedure for application based questions." },
      { text: "If you have Verilog codes for the exam learn them too." }
    ]}
    questions={[
      {
        text: "Design a combinational circuit with three inputs and one output. Draw the corresponding truth table and Logic diagrams. (a) The output is 1 when the binary value of the inputs is less than 3. The output is 0 otherwise. (b) The output is 1 when the binary value of the inputs is an even number."
      },
      {
        text: "Write Verilog codes with line by line comments for full subtractor in Structural Level, Data Flow Level and Behavioural Modelling"
      },
      {
        text: "Design a system which accepts 4-bit input (A,B,C,D) from user generates outputs X and Y. If the input is divisible by 4 or 5, then X=1 else 0. If the input is divisible by 2 or 3, then Y=1 else 0."
      },
      {
        text: "Design a combinational circuit with three inputs, x, y, and z, and three outputs, A, B, and C. When the binary input is 0, 1, 2, or 3, the binary output is one greater than the input. When the binary input is 4, 5, 6, or 7, the binary output is one less than the input. Write the Verilog code using data flow modelling for the designed circuit."
      },
      {
        text: "Design the full adder circuit using half adder and OR gate (Write the corresponding expression and truth table). Also, write the behavioral modelling Verilog code using case statements."
      },
      {
        text: "Design a Combinational circuit with three inputs, A, B, and C, and four outputs, U, V, W and X. Construct the circuit with two inputs NOR gate only. When the decimal value of input is 4, 5, 6, or 7 the binary output is one less than the input (input -1). When the decimal value of input is 0, 1, 2, or 3, the output is two greater than (input +2) the input."
      },
      {
        text: "A majority circuit is a combinational circuit whose output is equal to 1 if the input variables have more no. of 1’s than 0’s. The output is 0 otherwise. Design Using Boolean laws, three input Majority circuit with P, Q, R as input output Function Tand its complement circuit, Prove T=(T')'"
      },
      {
        text: "Design a combinational circuit with inputs D0, D1, D2, D3 and outputs X, Y, V. The operation of the combinational circuit must be such that if two or more inputs are equal to 1 at the same time, highest priority input among the inputs is considered. The order of priority is D0>D1>D2>D3. Here V is the valid bit indicator that is set to 1 when one or more inputs are equal to 1. and Write the Test Bench in Verilog to verify the design circuit above."
      },
      {
        text: "Design a combinational circuit with Full-adders and logic gates. The circuit produces the output as 5 times of its input. The size of input is 3bits."
      },
      {
        text: "Design Full adder and Full Subtractor using MUX. Write the mixed style Verilog code and test bench with line by line comments for Full subtractor implementation using MUX."
      },
      {
        text: "Implement 1:4 De-Multiplexer circuit using logic gates. Design a Combinational circuit with three inputs, x, y, and z, and three outputs, A, B, and C, in which the binary output is one greater than the input if the input is 0, 1, 2, or 3, else binary output is two less than the input using only De-Multiplexer and logic gates. Show the internal circuit of 1:8 DEMUX using 1:4 DEMUX with investors. Write the mixed style Verilog code and test bench with line by line comments of the above design."
      },
      {
        text: "Design a combinational circuit with three inputs x,y,and z and three outputs A,B,C using a Decoder and external gates. When the binary input is 0,1,2 or 3, the binary output is two greater than input. When the binary input is 4,5,6 or 7, The binary output is two less than the input"
      },
      {
        text: "The circuit has 3 bit binary inputs (A2,A1,A0) and their 2's complement as output (D2,D1,D0) write its truth table and then design using full adder"
      },
      {
        text: "Check whether both the Verilog code generates the same circuit. If so, from the following Verilog code (i) write the standard SOP & POS form Boolean expression (ii) write the canonical SOP & POS form Boolean expression (iii) draw the circuit diagram for standard SOP expression (iv) draw truth table (v) identify the application of the circuit.",
        image:"/dsd_8.png"
      },
      {
        text: "Check whether both the Verilog code generates the same circuit. If so, draw the circuit diagram, truth table, input and output waveforms. Write the standard SOP and POS and canonical SOP & POS forms Boolean Expression of the circuit",
        image:"/dsd_9.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default DesignProcedureHalfFullAddSub;
